export enum InvoiceManagerType {
    SaleOrder,
    Shipment,
    ConsolShipment,
    Other,
}
